import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  listSeatEmployee: [],
  getAllEmployee: {},
  createSeatEmployee: null,
  updateSeatEmployee: null,
  deleteSeatEmployee: null,
  listStaffSeat: [],
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  }
};

export const getters = {
  listSeatEmployee: state => state.listSeatEmployee,
  createSeatEmployee: state => state.createSeatEmployee,
  getAllEmployee: state => state.getAllEmployee,
  updateSeatEmployee: state => state.updateSeatEmployee,
  deleteSeatEmployee: state => state.deleteSeatEmployee,
  listStaffSeat: state => state.listStaffSeat,
  pagination: state => state.pagination,
};

export const mutations = {
  [types.SEAT_EMPLOYEE.LIST_SEAT_EMPLOYEE](state, data) {
    state.listSeatEmployee = data;
  },
  [types.SEAT_EMPLOYEE.CREATE_SEAT_EMPLOYEE](state, data) {
    state.createSeatEmployee = data;
  },
  [types.SEAT_EMPLOYEE.GET_EMPLOYEE_SEAT](state, data) {
    state.getAllEmployee = data;
  },
  [types.SEAT_EMPLOYEE.UPDATE_SEAT_EMPLOYEE](state, data) {
    state.updateSeatEmployee = data;
  },
  [types.SEAT_EMPLOYEE.DELETE_SEAT_EMPLOYEE](state, data) {
    state.deleteSeatEmployee = data;
  },
  [types.SEAT_EMPLOYEE.GET_STAFF_SEAT](state, data) {
    state.listStaffSeat = data.employees;
    state.pagination.from = data.employees.from;
    state.pagination.to = data.employees.to;
    state.pagination.totalPage = data.employees.last_page;
    state.pagination.path = data.employees.path;
    state.pagination.currentPage = data.employees.current_page;
    state.pagination.totalRecord = data.employees.total;
    state.pagination.perPage = data.employees.per_page;
  }
};

export const actions = {
  async listSeatEmployee({ commit }, floor) {
    let url = `${api.LIST_SEATING_CHART}?floor=${floor}`
    const response = await axios.get(url);
    commit(types.SEAT_EMPLOYEE.LIST_SEAT_EMPLOYEE, response.data);
  },
  async createSeatEmployee({ commit }, params) {
    const response = await axios.post(api.CREATE_SEAT, params);
    commit(types.SEAT_EMPLOYEE.CREATE_SEAT_EMPLOYEE, response.data);
  },
  //?paginate=0
  async getAllEmployee({ commit }) {
    let url = `${api.GET_ALL_LIST_EMPLOYEE_SEAT}?paginate=0`;
    const response = await axios.get(url);
    commit(types.SEAT_EMPLOYEE.GET_EMPLOYEE_SEAT, response.data);
  },
  async updateSeatEmployee({ commit }, params) {
    let url = `${api.UPDATE_SEAT}/${params.id}`;
    const response = await axios.post(url, params.data);
    commit(types.SEAT_EMPLOYEE.UPDATE_SEAT_EMPLOYEE, response.data);
  },
  async deleteSeatEmployee({ commit }, seatEmployeeId) {
    const response = await axios.delete(api.DELETE_SEAT + "/" + seatEmployeeId);
    commit(types.SEAT_EMPLOYEE.DELETE_SEAT_EMPLOYEE, response.data);
  },
  async listStaffSeat({ commit }) {
    const response = await axios.get(api.LIST_STAFF_SEAT);
    commit(types.SEAT_EMPLOYEE.GET_STAFF_SEAT, response.data);
  },
};
